<ng-container>
  <h6
    data-cy="address-data__title"
    class="navigation__medium--l udex-mb-xs-12 udex-mb-20">{{ header | cxTranslate }}</h6>

  <div class="row" *ngIf="address; else showSkeleton">
    <div
      data-cy="address-data__company-address"
      class="text-grey col-sm-6">
      <span [innerHTML]="address | transformAddresses"></span>
    </div>
    <div
      data-cy="address-data__alternative-address"
      class="col-sm-6">
      <ng-content></ng-content>
    </div>
  </div>
  <ng-template #showSkeleton>
    <div class="skeleton-height row">
      <div
        data-cy="address-data__company-address__skeleton"
        class="text-grey col-sm-6">
        <dcp-content-loading-indicator></dcp-content-loading-indicator>
      </div>
      <div
        data-cy="address-data__alternative-address__skeleton"
        class="col-sm-6">
        <dcp-content-loading-indicator></dcp-content-loading-indicator>
      </div>
    </div>
  </ng-template>
</ng-container>
